import { Storage } from '@ionic/storage';

const store = new Storage();
store.create();

export async function getStoreValue(key:string){
    return await store.get(key);
}

export async function setStoreValue(key:string, value:string){
    await store.set(key, value);
}